import {DumpsterFire} from "../../DumpsterFire";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {gsap, TimelineLite} from "gsap";


export class DFFSIntroRunner implements SimplePresentation {

    public shouldRun(): boolean {
        return DumpsterFire.model.data.mode.indexOf("NORMAL") > -1 && DumpsterFire.model.data.nextMode === DumpsterFireGameMode.FREESPIN && !DumpsterFire.model.data.isRestoreState && DumpsterFire.model.data.upgradedSymbols.length > 0;
    }


    public start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        DumpsterFire.keypadPlugin.setZeroBetSpinCounter(-1);
        tl.add(DumpsterFire.fsIntro.showIntro(() => this.showUpgrade(controller)), 0);
    }

    private showUpgrade(controller: SimplePresentationRunnerController): void {
      DumpsterFire.fsIntro.showUpgrades(() => this.finishController(controller));
    }

    private finishController(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback();
        controller.finish();
    }
}